import styled from 'styled-components';
import { ListItem } from '../../../../list-item';
import { getColorShade } from '../../../../../../src/styled/utils';
import { Icon } from '../../../../icon';
export const StyledSecondAction = styled.span `
  position: relative;
  width: 20px;
  height: 20px;
  opacity: 0;
`;
export const StyledListItem = styled(ListItem) `
  &:last-of-type {
    border: inherit;
  }

  &:hover {
    ${StyledSecondAction} {
      opacity: 1;
    }
  }
`;
export const StyledActionIcon = styled(Icon) `
  color: ${getColorShade('onSurface', 'lowEmphasis')};
`;
export const StyledRemoveIcon = styled(Icon).attrs({ name: 'close_outline' }) `
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
`;
